import React from 'react'
import BookingPaymentSuccessState from './BookingPaymentSuccessState'
import MemberBookingSuccess from '../components/MemberBookingSuccess'

export default function MemberSpaBookingSuccessPage({ clubCode }) {
  return <BookingPaymentSuccessState clubCode={clubCode} module="spa">
    <MemberBookingSuccess clubCode={clubCode} module="spa" />
  </BookingPaymentSuccessState>
}
